import React from "react";
import "./Loader.css";

export default function LoaderDeviceCard({
  label = "",
  fullscreen = true,
}) {
  return (
    <div className={`device-loader-overlay ${fullscreen ? "fullscreen" : ""}`}>
      <div className="loader-card">
        <div className="device-loader">
          <div className="phone-frame">
            <div className="phone-notch" />
            <div className="phone-screen">
              <div className="screen-shine"></div>
              <div className="signal-center">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
          <div className="pulse-ring"></div>
        </div>
        <p className="loader-label">{label}</p>
      </div>
    </div>
  );
}